import { render, staticRenderFns } from "./AppLogoSvg.vue?vue&type=template&id=77c44e32&"
import script from "./AppLogoSvg.vue?vue&type=script&lang=js&"
export * from "./AppLogoSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports